import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

export const getGetEDocPlanMock = () => ({
  ap_receipt_type_alert_type: faker.helpers.arrayElement([
    'none',
    'warning',
    'error',
  ] as const),
  ap_receipt_type_enabled_at: `${
    faker.date.past().toISOString().split('.')[0]
  }Z`,
  ex_receipt_type_alert_type: faker.helpers.arrayElement([
    'none',
    'warning',
    'error',
  ] as const),
  ex_receipt_type_enabled_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      `${faker.date.past().toISOString().split('.')[0]}Z`,
      null,
    ]),
  ]),
  ex_transaction_documents_begins_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      `${faker.date.past().toISOString().split('.')[0]}Z`,
      null,
    ]),
  ]),
  ex_transaction_reserve_documents_begins_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      `${faker.date.past().toISOString().split('.')[0]}Z`,
      null,
    ]),
  ]),
  free_term_begins_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      `${faker.date.past().toISOString().split('.')[0]}Z`,
      null,
    ]),
  ]),
  free_term_ends_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      `${faker.date.past().toISOString().split('.')[0]}Z`,
      null,
    ]),
  ]),
  invoice_report_documents_begins_at: faker.date
    .past()
    .toISOString()
    .split('T')[0],
  is_ex_transaction_documents: faker.datatype.boolean(),
  is_ex_transaction_reserve_documents: faker.datatype.boolean(),
  is_invoice_report_documents: faker.datatype.boolean(),
  member_upper_limit: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.number.int({ min: 1, max: 10 }), null]),
  ]),
  price: faker.number.int({ min: 1, max: 10 }),
  registered_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  withdrew_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      `${faker.date.past().toISOString().split('.')[0]}Z`,
      null,
    ]),
  ]),
});

export const handlers = [
  http.get('*/api/js/e_doc_plan', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetEDocPlanMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
];
